import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IAnalytics, IDateRange } from '../models/models'

export class SessionsPostApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/AnalyticsReporting/sessions',
      requesterInfo,
    })
  }

  public async sessionsPost(request: IDateRange): Promise<IAnalytics[]> {
    return await this.postAsync<IAnalytics[]>(request)
  }
}
